<template>
    <MeetingDetailsBlock
        iconName="user"
        title="Attendee"
    >
        <div class="truncate">
            {{ customer.getFullName() }}
        </div>
        <div class="text-sm truncate">
            {{ customer.email }}
        </div>
    </MeetingDetailsBlock>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import Customer from '@/App/Customer/Entity/Customer'

    const props = defineProps({
        customer: {
            type: Object as PropType<Customer>,
            required: true,
        },
    })
</script>
